import { PopUp } from '../types/popup';
import base from './base';

const popUps = {
  getPopUp() {
    return base.get<PopUp>(`/pop-ups/one`);
  },
};

export default popUps;
